/** UUID v4 compatível com HTTP e WebViews sem `crypto.randomUUID`. */
function uuidV4FromBytes(bytes: Uint8Array): string {
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
}

function randomUuidV4(): string {
  const bytes = new Uint8Array(16);

  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < 16; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }

  return uuidV4FromBytes(bytes);
}

/** ID estável em HTTP (crypto.randomUUID exige contexto seguro). */
export function generateFieldId(): string {
  const randomUuid = globalThis.crypto?.randomUUID;

  if (typeof randomUuid === 'function') {
    try {
      return randomUuid.call(globalThis.crypto);
    } catch {
      // segue para fallback
    }
  }

  return randomUuidV4();
}
